import React from 'react';
import { motion } from 'framer-motion';

const ValueStrip = () => {
  return (
    <motion.section
      id="value-proposition"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      style={{
        background: '#f8fafc',
        padding: '40px 0',
        borderBottom: '1px solid #e2e8f0'
      }}
    >
      <div className="container">
        <motion.p
          style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1e293b',
            textAlign: 'center',
            lineHeight: '1.6',
            maxWidth: '900px',
            margin: '0 auto'
          }}
        >
          We deliver tested, creative store designs that load extra-fast — and handle product uploads so you can start selling immediately.
        </motion.p>
      </div>
    </motion.section>
  );
};

export default ValueStrip;
